import { render } from "./Banbozhu2025.vue?vue&type=template&id=1340ea52&scoped=true"
import script from "./Banbozhu2025.vue?vue&type=script&lang=js"
export * from "./Banbozhu2025.vue?vue&type=script&lang=js"

import "./Banbozhu2025.vue?vue&type=style&index=0&id=1340ea52&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1340ea52"]])

export default __exports__